import { LoginArgs } from './inference.gen'
import { useTokenAndOrgId, InferenceAPI } from './utils'
import { useMutation, useQuery } from '@tanstack/react-query'

export const useGetUserOrgs = () => {
  const { token } = useTokenAndOrgId()

  return useQuery({
    queryKey: ['get-user-orgs', token],
    enabled: !!token,
    queryFn: async () => InferenceAPI.getUserOrgs(),
  })
}

export const ORG_NOT_FOUND_ERROR_MSG = 'Organization not found'
export const useGetOrgUserProfile = (orgId: number) => {
  const { token } = useTokenAndOrgId()

  return useQuery({
    queryKey: ['get-org-user-profile', orgId, token],
    enabled: !!token && !!orgId && orgId > 0,
    queryFn: async () => {
      const result = await InferenceAPI.getUserOrgs()
      if (!result.orgs) throw new Error(ORG_NOT_FOUND_ERROR_MSG)

      const org = result.orgs.find((org) => org.org.org_id === orgId)
      if (!org) throw new Error(ORG_NOT_FOUND_ERROR_MSG)

      return org
    },
  })
}

// MUTATIONS
export const useRequestOTP = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      return await InferenceAPI.requestOTP({ email })
    },
  })
}

export const useLogin = () => {
  return useMutation({
    mutationFn: async (body: LoginArgs) => {
      return await InferenceAPI.login(body)
    },
  })
}
